module.exports = __webpack_public_path__ + "img/awards.b45729e1.png";